import tmhRequest from "@/config/tmhRequest";

export default {
  searchMenuItem: function(data) {
    return tmhRequest({
      url: "/menu/tmh/menuitem/searchmenuitem",
      method: "post",
      params: data
    });
  },
  searchListMenuItem: function(data) {
    return tmhRequest({
      url: "/menu/tmh/menuitem/searchlistmenuitem",
      method: "post",
      params: data
    });
  },
  searchMenuItemCount: function(data) {
    return tmhRequest({
      url: "/menu/tmh/menuitem/searchmenuitemcount",
      method: "post",
      params: data
    });
  },
  searchMenuItemByPage: function(data) {
    return tmhRequest({
      url: "/menu/tmh/menuitem/searchmenuitembypage",
      method: "post",
      params: data
    });
  },
  searchListNoPlusMenuItem: function(data) {
    return tmhRequest({
      url: "/menu/tmh/menuitem/searchlistnoplusmenuitem",
      method: "post",
      params: data
    });
  },
  addMenuItem: function(data) {
    return tmhRequest({
      url: "/menu/tmh/menuitem/addmenuitem",
      method: "post",
      data: data
    });
  },
  editMenuItem: function(data) {
    return tmhRequest({
      url: "/menu/tmh/menuitem/editmenuitem",
      method: "post",
      data: data
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/tmh/menu/menuitem.js